export const stats = {
  table: {
    field: {
      campaign: 'Campaign',
      campaign_id: 'Campaign ID',
      task_number: 'Task number',
      src: 'Outgoing',
      dst: 'Incoming',
      date_time: 'Date and time',
      duration: 'Duration',
      client_action: 'Client action',
      cost: 'Cost',
      status: 'Status'
    }
  },

  filter: {
    campaign: '@:autoinformer.stats.table.field.campaign',
    status: '@:autoinformer.stats.table.field.status',
    task_number: '@:autoinformer.stats.table.field.task_number',
    src: '@:autoinformer.stats.table.field.src',
    dst: '@:autoinformer.stats.table.field.dst',
    client_action: '@:autoinformer.stats.table.field.client_action'
  },

  state: {
    ANSWERED: 'Answered',
    FAILED: 'Failed',
    NO_ANSWER: 'Unanswered',
    PROGRESS: 'In progress',
    SUBSCRIBER_ABSENT: 'Unavailable',
    CALL_TIMED_OUT: 'Timed out',
    CLIENT_DROPPED_CALL_OR_BUSY: 'Dropped the call or busy',
    NO_HUMAN: 'Answering machine'
  }
};
